/* @flow */

import React, { useContext } from "react";
import { StoreInfoContext, useClient } from "entrypoint/shared";
import { Checkout } from "@crossroads/shop-views";
import { useData } from "crustate/react";
import { AnalyticsContext } from "@crossroads/analytics";
import { QuoteData, CmsPageData } from "data";
import useFormat from "helpers/use-format";

import { altapay } from "config";

import CmsPageView from "components/CmsPageView";

const Overview = (): React$Node => {
  const cmsData = useData(CmsPageData);
  const quote = useData(QuoteData);
  const { formatPrice } = useFormat();
  const gaContext = useContext(AnalyticsContext);

  const agreementPage = cmsData.state === "LOADED" ? <CmsPageView cmsPage={cmsData.data} showBreadcrumbs={false} /> : null;

  return (
    <Checkout
      analytics={{ context: gaContext }}
      quote={quote}
      formatPrice={formatPrice}
      useClient={useClient}
      StoreInfoContext={StoreInfoContext}
      scriptURL={altapay.src}
      agreement={agreementPage}
    />
  );
};

export default Overview;
